/**
 * Redux witness watchers for pm-sections
 * @module services/testrossa/watchers
 */
import { List, Map } from 'immutable'
import {
  GET_TESTAROSSA_PROJECTS,
  GET_TESTAROSSA_CAMPAIGN,
  SET_TESTAROSSA_PROJECTS_DATA,
} from 'services/testarossa/redux/actions'
import { isLoggedIn } from '../auth'
import { PAGE_MANAGER_SECTION_VISIBILITY_TYPE_USER_TEST_GROUP } from './visibility-types'
import { SET_SECTIONS_DATA } from './redux/actions'

/**
 * Check if the location contains a page manager path
 * @param {import('immutable').Map} location A location map
 * @returns True when the path is related to page manager
 */
function isPageManagerPath (location) {
  const pathname = location.getIn(['data', 'pathname'])
  return /^\/page-manager\/?/.test(pathname)
}

/**
 * Handle sections data and get testarossa projects
 * @param {Object} options The options
 * @param {Function} options.after Witness after function
 */
export function onSetSectionsDataGetTestarossaProjects ({ after }) {
  return after([SET_SECTIONS_DATA], ({ dispatch }) => {
    dispatch({
      type: GET_TESTAROSSA_PROJECTS,
      payload: { processing: true },
    })
  })
    .when(({ state }) => {
      const { location, testarossa, auth } = state
      const projects = testarossa.getIn(['projects', 'data']) || List()
      return isLoggedIn(auth) && isPageManagerPath(location) && projects.isEmpty()
    })
}

/**
 * Handle set testarossa projects data which in this case will come after
 * set pm-sections data and get multiple testarossa campaigns
 * @param {Object} options The options
 * @param {Function} options.after Witness after function
 */
export function onSetTestarossaProjectDataGetTestarossaCampaigns ({ after }) {
  return after([SET_TESTAROSSA_PROJECTS_DATA], ({ state, dispatch, action }) => {
    const { payload: { data = Map() } } = action
    const { pmSection = Map() } = state
    const sections = pmSection.get('sections') || Map()
    const projectUuids = sections.toList().flatMap((section) => {
      // Get the section visibility
      const visibility = section.get('visibility') || List()
      // From the visibility get all of the user-test-group types
      // with a campaign uuid and then return just the campaign uuids
      return visibility.filter((v) => v.get('type') === PAGE_MANAGER_SECTION_VISIBILITY_TYPE_USER_TEST_GROUP && v.get('projectUuid'))
        .map((v) => v.get('projectUuid'))
    }).toSet()
    // Only load campaigns for the pm-section projects
    const campaignUuids = data.toList().flatMap((item) => {
      if (!projectUuids.includes(item.get('uuid'))) {
        return List()
      }
      const campaigns = item.get('campaigns') || List()
      return campaigns.map((v) => v.get('uuid'))
    }).toSet()
    campaignUuids.forEach((uuid) => dispatch({
      type: GET_TESTAROSSA_CAMPAIGN,
      payload: { uuid },
    }))
  })
}
